// extracted by mini-css-extract-plugin
module.exports = {"clickable":"GrayCard_clickable__1ZHzE","container":"GrayCard_container__20X3e"};